import React from 'react';
import { observer } from 'mobx-react-lite';
import { BetResponseCode, notificationStore, roundInfoStore } from '@pascal/pascal-core';

import { BetAmountSection } from './betAmountSection';
import { plus } from '../../helpers/arithmeticOperations';
import { globalTranslationKeys } from '../../enums';
import { doBetStore } from '../../store';

export const BetSection = observer(
  ({
    t,
    odd,
    isDemo,
    limits,
    betAmount,
    reBetData,
    setBetAmount,
    activeButton,
    activeFreeBet,
    handleClickBet,
    totalBetsAmount,
    handleInputBlur,
    betPendingToggle,
    reBetPendingToggle,
    partnerWageringOdd,
    decidedCallBackCall,
    setIsValidatedAmount,
    handleChangeInputValue,
  }) => {
    const { InValidMaxBet } = BetResponseCode;
    const hasReBet = reBetData.length && reBetData[0].roundId !== roundInfoStore.roundId;

    return (
      <div className='g-bot-area-bet'>
        <div className='g-bot-area-bet-left'>
          <BetAmountSection
            t={t}
            isDemo={isDemo}
            limits={limits}
            betAmount={betAmount}
            onBlur={handleInputBlur}
            setBetAmount={setBetAmount}
            activeFreeBet={activeFreeBet}
            setIsValidatedAmount={setIsValidatedAmount}
            handleChangeInputValue={handleChangeInputValue}
          />
        </div>
        <div className='g-bot-area-bet-right'>
          <div
            className={`bet-right-btn bet ${
              (!activeButton &&
                !betPendingToggle &&
                !reBetPendingToggle &&
                !activeFreeBet.id &&
                !partnerWageringOdd) ||
              ((activeFreeBet.minOdd <= odd || (partnerWageringOdd <= odd && !activeFreeBet.id)) &&
                !isDemo &&
                !activeButton &&
                !betPendingToggle &&
                !reBetPendingToggle)
                ? 'pulse-anim'
                : 'dsb'
            } ${hasReBet ? 'rebet' : ''}`}
          >
            <button
              disabled={activeButton || betPendingToggle || reBetPendingToggle}
              className={`btn-game ${
                activeButton || betPendingToggle || reBetPendingToggle ? 'disabled' : ''
              } ${!isDemo && (activeFreeBet.id || partnerWageringOdd) ? 'free-bet' : ''} ${
                (activeFreeBet.minOdd > odd && !isDemo) ||
                (partnerWageringOdd > odd && !activeFreeBet.id && !isDemo)
                  ? 'free-bet_disabled'
                  : ''
              }`}
              onClick={() => {
                if (
                  isDemo &&
                  plus(Number(betAmount), Number(totalBetsAmount)) > Number(limits.maxBet)
                ) {
                  notificationStore.setNotificationType({ responseCode: InValidMaxBet });
                } else {
                  decidedCallBackCall(handleClickBet);
                }
              }}
            >
              <span className='btn-game-txt'>
                {activeFreeBet.id && !isDemo
                  ? `${t('FREE_BET')} ${activeFreeBet.remainingCount}`
                  : t('BET')}
              </span>
              <span className='btn-game-small-txt'>
                {((activeFreeBet.id && !activeFreeBet.isMinOddNull) || partnerWageringOdd) &&
                !isDemo
                  ? `${t('MIN_ODD')} x${
                      activeFreeBet.id ? activeFreeBet.minOdd : partnerWageringOdd
                    }`
                  : ''}
              </span>
            </button>
            {betPendingToggle && (
              <div className={`circle-loader ${hasReBet ? 'sm-bt' : 'default-loader'}`} />
            )}
          </div>
          {!!hasReBet && (
            <button
              className={`new-rebet-btn ${
                !activeButton && !betPendingToggle && !reBetPendingToggle ? 'pulse-anim' : 'dsb'
              }`}
              onClick={() => doBetStore.handleReBetClick()}
            >
              <i className='ui-lib-new-rebet' />
              <span className='rebet-text'>{t(globalTranslationKeys.ReBet)}</span>
              {reBetPendingToggle && <div className='circle-loader sm-bt' />}
            </button>
          )}
        </div>
      </div>
    );
  }
);
